import React from "react";
import "./index.css";

const Hero = () => {
  return (
    <div className="Hero jumbotron jumbotron-fluid">
      <div className="Hero__container container">
        <div className="row">
          <div className="Hero__title-container col-8 col-md-8">
            <h1 className="Hero__title">
              Comparação 
              <span className="Hero__title--bolder"> de</span>
              <span className="Hero__title--yellow"> Rentabilidades</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
